import { debounce } from './helpers.js';

export default () => {

    const nodeSelectors = {
        container: 'video',
        source: 'source',
    };


    function init() {

        const videos =
            document.querySelectorAll(
                nodeSelectors.container
            );


        if (!videos.length) {
            return;
        }


        // Initial load
        handleVideos();


        // Resize
        window.addEventListener(
            'resize',
            debounce(() => {

                handleVideos();

            })
        );

    }


    function handleVideos() {

        const videos =
            document.querySelectorAll(
                nodeSelectors.container
            );


        videos.forEach(
            (video) => {

                handleVideo(
                    video
                );

            }
        );

    }


    function handleVideo(video) {

        if (!video) {
            return;
        }


        /*
         * IMPORTANT
         * --------------------------------------------------
         *
         * These videos are now managed by:
         *
         * media-slider.js
         * media.js
         *
         * Do NOT touch them here.
         */
        if (
            video.hasAttribute(
                'data-deferred-video'
            ) ||
            video.hasAttribute(
                'data-desktop-src'
            ) ||
            video.hasAttribute(
                'data-mobile-src'
            )
        ) {

            return;

        }


        /*
         * Get traditional <source> elements.
         */
        const sources =
            Array.from(
                video.querySelectorAll(
                    nodeSelectors.source
                )
            );


        /*
         * IMPORTANT:
         * querySelectorAll always returns a collection.
         */
        if (!sources.length) {
            return;
        }


        const newSource =
            getBestSource(
                sources
            );


        /*
         * getBestSource is allowed to return null.
         */
        if (!newSource) {
            return;
        }


        const newSrc =
            newSource.getAttribute(
                'src'
            );


        if (!newSrc) {
            return;
        }


        /*
         * Compare against current loaded source.
         */
        const currentSrc =
            video.getAttribute(
                'src'
            );


        if (
            currentSrc !== newSrc
        ) {

            video.src =
                newSrc;


            video.load();

        }


        if (
            newSource.hasAttribute(
                'muted'
            )
        ) {

            video.muted =
                true;

        }

    }


    function getBestSource(
        sources
    ) {

        if (
            !sources ||
            !sources.length
        ) {

            return null;

        }


        let fallbackSource =
            null;


        for (
            let i = 0;
            i < sources.length;
            i++
        ) {

            const source =
                sources[i];


            if (!source) {
                continue;
            }


            const src =
                source.getAttribute(
                    'src'
                );


            if (!src) {
                continue;
            }


            const media =
                source.getAttribute(
                    'media'
                );


            /*
             * Source without media becomes fallback.
             */
            if (!media) {

                if (!fallbackSource) {

                    fallbackSource =
                        source;

                }


                continue;

            }


            try {

                const mediaQuery =
                    window.matchMedia(
                        media
                    );


                if (
                    mediaQuery.matches
                ) {

                    return source;

                }

            } catch (error) {

                console.warn(
                    'Invalid video media query:',
                    media
                );

            }

        }


        /*
         * Standard fallback source.
         */
        if (fallbackSource) {

            return fallbackSource;

        }


        /*
         * Last safe fallback.
         */
        const firstValidSource =
            sources.find(
                (source) => {

                    return (
                        source &&
                        source.getAttribute(
                            'src'
                        )
                    );

                }
            );


        return (
            firstValidSource ||
            null
        );

    }


    return Object.freeze({
        init,
        handleVideo,
        nodeSelectors,
    });

};